import { weixinConfig, updateWeixinShareConfig } from '@/methods/share'

const shareMixin = {
    methods: {
        async shareConfig () {
            await weixinConfig()
        },
        updateWeixinShareConfig (config) {
            updateWeixinShareConfig(config)
        }
    },
    mounted () {
        this.shareConfig()
    }
}

export default shareMixin



// WEBPACK FOOTER //
// ./src/mixins/share.js